import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "o-anim-fade-200",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("button", {
        key: _ctx.iconName,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleNetPrice && _ctx.toggleNetPrice(...args)))
      }, [
        _createVNode(_component_c_icon, {
          name: _ctx.iconName,
          class: "h-18"
        }, null, 8, ["name"])
      ]))
    ]),
    _: 1
  }))
}